import axios from 'axios'
import store from '@/store'


const server = axios.create({
    baseURL: 'https://api.aniresan.com/',
});

server.interceptors.request.use(function (config) {
    store.dispatch("addPendingRequest", config);
    return config;

}, function (error) {
    return Promise.reject(error);
});

server.interceptors.response.use((response) => {
    store.dispatch("removePendingRequest", response.config);

    return response;

}, function (error) {
    store.dispatch("removePendingRequest", error.config);

    return Promise.reject(error)
});


export default server;